var exports = {
  "i": "xfd349460--2d7392--wrapper",
};

module.exports = exports;
